var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, cloneElement } from 'react';
import ECharts from '../ECharts';
import XAxis from '../components/XAxis';
import YAxis from '../components/YAxis';
import Legend from '../components/Legend';
import Tooltip from '../components/Tooltip';
import Bars from '../series/Bars';
import { is, isSeries } from '../utils';
import { EChartsContext } from '../constants';
const categoryAxisProps = {
    type: 'category',
    splitLine: false
};
const valueAxisProps = {
    type: 'value'
};
/**
 * <ECharts>
 *   <XAxis />
 *   <YAxis />
 *   <Bars />
 *   <Tooltip />
 *   <Legend />
 * </ECharts>
 */
function BarChart(_a, ref) {
    var { name, data: inputData = [], tooltip = true, xAxis = true, yAxis = true, horizontal = false, legend = true, children } = _a, props = __rest(_a, ["name", "data", "tooltip", "xAxis", "yAxis", "horizontal", "legend", "children"]);
    function renderDefaultCategoryAxis() {
        const data = horizontal ? [...inputData].reverse() : inputData;
        const categories = data.map(([category]) => category);
        return horizontal ? (React.createElement(YAxis, Object.assign({}, categoryAxisProps, { data: categories }))) : (React.createElement(XAxis, Object.assign({}, categoryAxisProps, { data: categories })));
    }
    function renderDefaultValueAxis() {
        return horizontal ? (React.createElement(XAxis, Object.assign({}, valueAxisProps, { show: xAxis }))) : (React.createElement(YAxis, Object.assign({}, valueAxisProps, { show: yAxis })));
    }
    function renderDefaultSeries() {
        // 水平图表从上往下阅读则需将 data 翻转过来
        const data = horizontal ? [...inputData].reverse() : inputData;
        const values = data.map(d => d[1]);
        return React.createElement(Bars, { name: name, data: values });
    }
    function renderDefaultLegend() {
        const components = Children.toArray(children);
        const series = components.filter(isSeries);
        const dataNames = series.length ? series.map((serie) => serie.name) : [name];
        return React.createElement(Legend, { data: dataNames });
    }
    const components = Children.toArray(children);
    const series = components.filter(isSeries);
    const data = horizontal ? [...inputData].reverse() : inputData;
    const categoryAxis = horizontal
        ? components.find((comp) => is(comp, 'yAxis'))
        : components.find((comp) => is(comp, 'xAxis'));
    const valueAxis = horizontal
        ? components.find((comp) => is(comp, 'xAxis'))
        : components.find((comp) => is(comp, 'yAxis'));
    return (React.createElement(EChartsContext.Provider, { value: { chartType: 'bar', horizontal } },
        React.createElement(ECharts, Object.assign({ ref: ref }, props),
            !categoryAxis && renderDefaultCategoryAxis(),
            !valueAxis && renderDefaultValueAxis(),
            !components.find((comp) => is(comp, 'bars')) && renderDefaultSeries(),
            legend && !components.find((comp) => is(comp, 'legend')) && renderDefaultLegend(),
            tooltip && React.createElement(Tooltip, null),
            components.map((child) => {
                if (child.type === (horizontal ? YAxis : XAxis)) {
                    return cloneElement(child, Object.assign(Object.assign({}, categoryAxisProps), { data: child.props.data || data.map(([category]) => category) }));
                }
                if (child.type === (horizontal ? XAxis : YAxis)) {
                    return cloneElement(child, valueAxisProps);
                }
                if (data.length && isSeries(child) && !child.props.data) {
                    const serieIndex = series.indexOf(child);
                    return cloneElement(child, { data: data.map(d => d[serieIndex + 1]) });
                }
                return child;
            }))));
}
export default React.forwardRef(BarChart);
//# sourceMappingURL=BarChart.js.map